import { useEffect } from 'react';
import { registerPushNotificationInteraction } from '../endpoints/api';

type ApiSource = 'foreground' | 'background' | 'killed' | 'web';

export const PENDING_INTERACTIONS_KEY = 'pending_interactions';

// Capture at module load time — before React Router can navigate away on unauthenticated routes.
const initialSearch = window.location.search;

// Expo WebView passes internal source labels that differ from API enum values — normalise them.
const normalizeSource = (raw: string | null): ApiSource => {
    if (raw === 'foreground') return 'foreground';
    if (raw === 'web') return 'web';
    if (raw === 'killed' || raw === 'expo_initial') return 'killed';
    // firebase_background, expo_response, background, or any unknown value → background
    return 'background';
};

export const useNotificationInteractionTracking = () => {
    useEffect(() => {
        const params = new URLSearchParams(initialSearch);
        const messageUuid = params.get('message_uuid');
        const source = normalizeSource(params.get('source'));

        if (!messageUuid) return;

        // Clean URL immediately — prevents re-tracking on page refresh
        params.delete('message_uuid');
        params.delete('source');
        const newSearch = params.toString();
        history.replaceState(
            null,
            '',
            `${window.location.pathname}${newSearch ? '?' + newSearch : ''}`,
        );

        const token = localStorage.getItem('user_token');
        if (!token) {
            const existing = JSON.parse(sessionStorage.getItem(PENDING_INTERACTIONS_KEY) || '[]');
            existing.push({
                message_uuid: messageUuid,
                source,
                occurred_at: new Date().toISOString(),
            });
            sessionStorage.setItem(PENDING_INTERACTIONS_KEY, JSON.stringify(existing));
            return;
        }

        registerPushNotificationInteraction({
            message_uuid: messageUuid,
            interaction_type: 'clicked',
            source,
            destination_url: window.location.href,
            occurred_at: new Date().toISOString(),
        }).catch(() => {});
    }, []);
};
